<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Send Sale to Lightspeed</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="alert alert-info">
      This will open the current sale in Lightspeed, in a new browser tab.
      <br><br>
      If you are not logged into Lightspeed, please log in before opening the sale.
      <br><br>
      Please ensure the Lightspeed web register is not already open, as Lightspeed only allows one web register tab to be open at a time.
    </div>

    <div *ngIf="loadingRegisters" class="text-muted">
      Loading registers...
    </div>

    <ng-container *ngIf="!loadingRegisters">

      <ng-container *ngIf="locationLinked && registers.length > 0">
        <div class="form-group">
          <label for="registerSelect">Lightspeed register</label>
          <select id="registerSelect"
                  name="registerSelect"
                  class="form-control"
                  ngbAutofocus
                  [(ngModel)]="selectedRegisterId">
            <option *ngFor="let register of registers" [ngValue]="register.id">
              {{ register.name }}
            </option>
          </select>
          <small class="form-text text-muted">
            The selected register will be associated with the sale, overriding whichever register you are currently logged into in Lightspeed.
          </small>
        </div>
      </ng-container>

      <ng-container *ngIf="locationLinked && registers.length === 0">
        <div class="alert alert-warning">
          No Lightspeed registers are configured for this sale's location<span *ngIf="locationName"> ({{ locationName }})</span>.
          You may proceed without selecting a register, or set up a register in Lightspeed first.
        </div>
      </ng-container>

      <ng-container *ngIf="!locationLinked">
        <div class="alert alert-warning">
          The sale's Capitan location<span *ngIf="locationName"> ({{ locationName }})</span> is not linked to a Lightspeed location.
          To select a register, link the location in
          <a routerLink="/organization-settings" fragment="integrations-header"
             (click)="activeModal.dismiss()">
            Organization Settings &rarr; Integrations</a>.
          You may also proceed without selecting a register.
        </div>
      </ng-container>

    </ng-container>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <ng-container *ngIf="!loadingRegisters">
      <button type="button" class="btn btn-primary"
              *ngIf="locationLinked && registers.length > 0"
              (click)="handleSave()"
              [disabled]="selectedRegisterId === null"
              [class.disabled]="selectedRegisterId === null">
        Submit
      </button>
      <button type="button" class="btn btn-primary"
              *ngIf="!locationLinked || registers.length === 0"
              (click)="handleSendWithoutRegister()">
        Send without register
      </button>
    </ng-container>
  </div>

</ng-container>
